import { storeManager } from '@pressreader/appstore';

import { MODULE_NAME } from '../constants';

import { saga } from './sagas';

storeManager.addFeature(MODULE_NAME, undefined, saga);

export * from './actions';
export * from './selectors';
